exports = module.exports = require("../../../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nhr[data-v-8ad757da] {\n  width: 100%;\n  margin-right: 15px;\n  margin-left: 15px;\n  margin-top: 4px;\n}\nspan.input-group-addon[data-v-8ad757da] {\n  cursor: pointer;\n  background: #1b6aaa;\n  color: white;\n}\nspan.input-group-addon[data-v-8ad757da]:hover {\n    background: #143b63;\n}\n.advantage_item[data-v-8ad757da] {\n  border-bottom: 1px solid #1e95e2;\n}\n.advantage_item .text-info[data-v-8ad757da] {\n    cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-8ad757da","scoped":true,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/sass-loader?{"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Techcenter/components/TcInputAdvantages.vue
// module id = 799
// module chunks = 1